import { render, staticRenderFns } from "./screen-1.vue?vue&type=template&id=577be124&scoped=true&"
import script from "./screen-1.vue?vue&type=script&lang=js&"
export * from "./screen-1.vue?vue&type=script&lang=js&"
import style0 from "./screen-1.vue?vue&type=style&index=0&id=577be124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577be124",
  null
  
)

export default component.exports